function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  stroke: "currentColor",
  className: "shopping-bag-fill_svg__st0",
  d: "M130.268 168.86h-113.9c-2.6 0-5.1-1.2-6.7-3.2-1.6-2-2.3-4.6-1.9-7.1l10.5-117.1v-.1c.8-4.2 4.4-7.2 8.6-7.2h93.1c4.3 0 7.9 3 8.6 7.2v.2l10.2 117c.4 2.5-.3 5.1-1.9 7.1-1.6 2-4 3.2-6.6 3.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  stroke: "currentColor",
  strokeWidth: "inherit",
  className: "shopping-bag-fill_svg__st0",
  d: "M97.1 61.9c-1.3 0-2.4-1.1-2.4-2.4V31.6c0-11.6-9.4-21-21-21s-21 9.4-21 21v27.9c0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1.1-2.4-2.4V31.6c0-14.3 11.6-25.9 25.9-25.9 14.3 0 25.9 11.6 25.9 25.9v27.9c-.2 1.4-1.3 2.4-2.6 2.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "inherit",
  transform: "rotate(-76.809 50.176 59.52)",
  className: "shopping-bag-fill_svg__st0",
  cx: 50.2,
  cy: 59.5,
  r: 5.1
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "inherit",
  transform: "rotate(-45.001 97.107 59.521)",
  className: "shopping-bag-fill_svg__st0",
  cx: 97.1,
  cy: 59.5,
  r: 5.1
});

function SvgShoppingBagFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.3 178.3",
    fill: "currentColor",
    strokeWidth: 4
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgShoppingBagFill;